import { render, staticRenderFns } from "./diagnosisForm.vue?vue&type=template&id=1c8449b2&scoped=true&"
import script from "./diagnosisForm.vue?vue&type=script&lang=js&"
export * from "./diagnosisForm.vue?vue&type=script&lang=js&"
import style0 from "./diagnosisForm.vue?vue&type=style&index=0&id=1c8449b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8449b2",
  null
  
)

export default component.exports